/**
 * *** SESSION_IDLE_TIMEOUT_SECONDS ***
 * Total allowed idle time (in seconds) before the user is automatically logged out.
 */
export const SESSION_IDLE_TIMEOUT_SECONDS = 2 * 60 * 60; // 2 hours

/**
 * *** SESSION_IDLE_TIMEOUT_WARNING_SECONDS ***
 * Duration (in seconds) before session expiry when the logout warning modal appears.
 */
export const SESSION_IDLE_TIMEOUT_WARNING_SECONDS = 5 * 60; // 5mins

/**
 * Ch
 */
export const APP_BUILD_VERSION_CHECK_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes
